const modules = {
  register: {
    insurances: true,
    favorites: true,
  },
  drawer: {
    partners: false,
    emergencyPetCareRelay: false,
  },
  contact: {
    liveChat: true,
  },
  others: {
    ThirtyMillionsFriends: false,
    emergencyPetCareRelay: false,
  },
  missingImages: false,
}

export default modules
